import { ICreateRequisicaoCompraUseCase } from "../../../presentation/useCases/create/create_requisicao_compra_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * CreateRequisicaoCompraUseCase
 */

export class CreateRequisicaoCompraUseCase implements ICreateRequisicaoCompraUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async createRequisicaoCompra(
    status: number,
    aprovadoPor: number | null,
    dataAprovadoPor: Date | null,
    dataCadastro: Date,
    solicitante: number | null,
    dataRequisicao: Date | undefined,
    centroCusto: number | null,
    dataPrevistaUtilizacao: Date | undefined,
    descricao: string | null,
    observacao: string | null,
    arquivo1: File | undefined,
    arquivo2: File | undefined,
  ): Promise<number> {
    return await this.repository.createRequisicaoCompra(
      status,
      aprovadoPor,
      dataAprovadoPor,
      dataCadastro,
      solicitante,
      dataRequisicao ?? null,
      centroCusto,
      dataPrevistaUtilizacao ?? null,
      descricao,
      observacao,
      arquivo1 ?? null,
      arquivo2 ?? null,
    );
  }
}
